module.exports = __webpack_public_path__ + "img/am09.3e206911.jpg";